




























import {
  DocumentType,
  FinanceType,
  LoadingStatusType,
  ProductVatType,
  SettingTaxInvoiceType,
  TransactionType,
} from "@/enums/enums";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { SettingTaxInvoiceModel } from "@/model/setting";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreUserInfo = namespace("UserInfo");
const StoreTransaction = namespace("Transaction");
const StoreSetting = namespace("Setting");

@Component
export default class SectionHeader extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  private doSuggestDocumentNumber = false;

  @StoreTransaction.Getter
  private getTransactionNumberLoadingStatus!: LoadingStatusType;

  @StoreTransaction.Action
  private DoGetSuggestionTransactionNumber!: (transactionCreate: any) => void;
  @StoreSetting.Getter
  private getSettingTaxInvoice!: SettingTaxInvoiceModel | null;
  @StoreUserInfo.Getter
  private getMerchant!: SelectedMerchantModel;

  created() {
    this.SetValueIsCreatedTaxInvoice();
    this.DoGetSuggestionTransactionNumber(this.transactionCreate);
    this.doSuggestDocumentNumber = true;
  }

  get transactionType() {
    return this.transactionCreate.transactionType;
  }

  get financeType() {
    return this.transactionCreate.financeType;
  }

  get sameProductVatType() {
    return this.transactionCreate.transactionSummary.sameProductVatType;
  }

  get isServiceOnly() {
    return this.transactionCreate.transactionSummary.isServiceOnly;
  }

  get canCreateTaxInvoiceNotVat() {
    return this.getSettingTaxInvoice ? this.getSettingTaxInvoice.canCreateTaxInvoiceNotVat : false;
  }

  get settingInvoiceTaxInvoiceType() {
    return this.getSettingTaxInvoice
      ? this.getSettingTaxInvoice.invoiceTaxInvoiceType
      : SettingTaxInvoiceType.AutoIssueTaxInvoice;
  }

  get settingReceiptTaxInvoiceType() {
    return this.getSettingTaxInvoice
      ? this.getSettingTaxInvoice.receiptTaxInvoiceType
      : SettingTaxInvoiceType.IssueTaxInvoice;
  }

  get isDisabled() {
    let disabled = false;
    if (this.getMerchant && !this.getMerchant.isVat) {
      disabled = true;
    } else if (this.financeType === FinanceType.InFlow) {
      switch (this.transactionType) {
        case TransactionType.Receipt:
          if (this.canCreateTaxInvoiceNotVat) {
            disabled = false;
          } else {
            disabled = this.sameProductVatType === ProductVatType.None;
          }
          break;
        case TransactionType.Invoice:
          if (this.canCreateTaxInvoiceNotVat) {
            disabled = false;
          } else {
            disabled = this.sameProductVatType === ProductVatType.None;
          }
          break;
      }
    }
    return disabled;
  }

  get sameProductVatTypeIdTransactionItemTypeProduct() {
    return this.transactionCreate.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct;
  }

  @Watch("transactionCreate.date.value", { deep: true })
  transactionCreateDateValueChanged(newValue: any, oldValue: any) {
    if (newValue != oldValue) {
      if (this.transactionCreate.documentType === DocumentType.Create) {
        if (this.getTransactionNumberLoadingStatus !== LoadingStatusType.Loading) {
          this.DoGetSuggestionTransactionNumber(this.transactionCreate);
        } else {
          this.doSuggestDocumentNumber = true;
        }
      }
    }
  }

  @Watch("transactionCreate.issueTaxInvoice.value", { deep: true })
  transactionCreateIssueTaxInvoiceValueChanged(newValue: any, oldValue: any) {
    if (newValue != oldValue) {
      if (this.transactionCreate.documentType === DocumentType.Create) {
        if (this.getTransactionNumberLoadingStatus !== LoadingStatusType.Loading) {
          this.DoGetSuggestionTransactionNumber(this.transactionCreate);
        } else {
          this.doSuggestDocumentNumber = true;
        }
      }
    }
  }

  @Watch("getTransactionNumberLoadingStatus", { deep: true })
  transactionNumberLoadingStatusChanged(newValue: any, oldValue: any) {
    if (this.doSuggestDocumentNumber) {
      this.doSuggestDocumentNumber = false;
      this.DoGetSuggestionTransactionNumber(this.transactionCreate);
    }
  }

  public SetValueIsCreatedTaxInvoice() {
    if (this.getMerchant && !this.getMerchant.isVat) {
      this.transactionCreate.issueTaxInvoice.value = false;
    } else if (this.transactionType === TransactionType.Invoice) {
      if (!this.transactionCreate.issueTaxInvoice.isNotAuto && !this.isDisabled) {
        if (this.financeType == FinanceType.OutFlow) {
          this.transactionCreate.issueTaxInvoice.value = this.isServiceOnly
            ? false
            : this.sameProductVatType !== ProductVatType.None;
        } else {
          if (this.settingInvoiceTaxInvoiceType == SettingTaxInvoiceType.IssueTaxInvoice) {
            this.transactionCreate.issueTaxInvoice.value = true;
          } else if (this.settingInvoiceTaxInvoiceType == SettingTaxInvoiceType.NotIssueTaxInvoice) {
            this.transactionCreate.issueTaxInvoice.value = false;
          } else if (this.settingInvoiceTaxInvoiceType == SettingTaxInvoiceType.AutoIssueTaxInvoice) {
            this.transactionCreate.issueTaxInvoice.value = this.isServiceOnly
              ? false
              : this.GetAutoIssueTaxInvoiceForInvoice();
          }
        }
      }
    } else if (this.transactionType === TransactionType.Receipt) {
      if (!this.transactionCreate.issueTaxInvoice.isNotAuto && !this.isDisabled) {
        if (this.settingReceiptTaxInvoiceType == SettingTaxInvoiceType.IssueTaxInvoice) {
          this.transactionCreate.issueTaxInvoice.value = true;
        } else if (this.settingReceiptTaxInvoiceType == SettingTaxInvoiceType.NotIssueTaxInvoice) {
          this.transactionCreate.issueTaxInvoice.value = false;
        }
      }
    }
  }

  public GetAutoIssueTaxInvoiceForInvoice() {
    let issueTaxInvoice = false;
    if (this.sameProductVatType !== ProductVatType.None) {
      if (this.sameProductVatTypeIdTransactionItemTypeProduct !== ProductVatType.None) {
        issueTaxInvoice = true;
      }
    }
    return issueTaxInvoice;
  }
}
